import { Route, Routes } from 'react-router-dom'
import ErrorPage, { ErrorType } from '../../../controls/ErrorPage'
import { TrackerProjectPage } from './TrackerProjectPage'
import { WaveRoutes } from './WaveRoutes'

export const TrackerRoutes = () => {
  return (
    <Routes>
      <Route index element={<TrackerProjectPage />} />
      {/* A wave's own steps. Nested rather than declared in containers/Page so
          the 2nd segment stays "wave" — "survey"/"fdchat" there would be
          shadowed by the single-market routes. */}
      <Route path="wave/:waveId/*" element={<WaveRoutes />} />
      <Route
        path="*"
        element={<ErrorPage errorType={ErrorType.NotFound404} />}
      />
    </Routes>
  )
}
